import React from "react";
import { isWeb } from "../../bridges/BridgeServices";
import { isTokenPresent } from "../../utils/cookieHelper";
import "./Chatbot.scss";
import { useChatbotSdk } from "./ChatbotSdk";
import { CHATBOT_CONTEXT } from "../../utils/constants";

const Chatbot = () => {
  // load chatbot sdk when there's a token in the cookie
  if (!isWeb()) {
    return null;
  }

  if (
    isTokenPresent() &&
    !document?.getElementById("mobile-chat-container")
  ) {
    return <ChatbotSdk />;
  }
  return null;
};
const ChatbotSdk = () => {
  useChatbotSdk();
  return null;
};
export default Chatbot;

Chatbot.propTypes = {
  chatBotContext: CHATBOT_CONTEXT,
};
